<template lang='pug'>
v-app#vapp_10_1(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md9, lg8, text-xs-center)
          v-card(flat)
            breadcrumb(back='page7-2')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero contratar mi Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider
              | VALIDA TUS REQUERIMIENTOS
            v-card-text.text-xs-center.titulo18Reg
              | Selecciona SI o NO cumples con cada uno de los requerimientos y revisa la información correspondiente.
            v-layout.pb-0.ma-0(row, justify-center)
              v-flex.pb-0.ma-0(xs12)
                v-layout.pa-0.pl-4.ma-1.my-0.py-0(row, align-center)
                  v-flex.label16tt_blue.pa-0.ma-0.text-xs-left(xs8, sm8)
                    | REQUISITOS DEL SOLICITANTE
                  v-flex.pa-0.ma-0(xs2, sm2)
                    | CUMPLO / NO CUMPLO
                  v-flex.pl-4.ma-0(xs2, sm3)
            v-layout.pb-4.ma-0.pt-0(row, justify-center)
              v-flex.py-0.ma-0(xs12)
                v-layout.pa-0.pl-4.ma-1.leftBlueBorder(row, align-center, v-for='i in 4', :key='i')
                  v-flex.pa-0.ma-0.text-xs-left(xs8, sm8)
                    .parrafoDestacadoB.px-3
                      b {{reactivos[i-1].descripcion}}
                  v-flex.pa-0.ma-0(xs2, sm1)
                    v-btn.toggle.ma-1(:color='testValue(reactivos[i-1].respuesta, true)', @click.prevent='reactivos[i-1].respuesta=true;', block, value='true')
                      | Sí
                  v-flex.pa-0.ma-0(xs2, sm1)
                    v-btn.toggle.ma-2(:color='testValue(reactivos[i-1].respuesta, false)', @click.prevent='reactivos[i-1].respuesta=false;', block, value='false')
                      | No
                  v-flex.pl-4.ma-0(xs2, sm3)
                    v-popover(offset='16', placement='right', trigger='hover' :disabled='reactivos[i-1].respuesta == "none"' )
                      v-icon.tooltip-target.info_tooltip(size='20px ', :color='testValue(reactivos[i-1].respuesta == "none", false)')
                        | fas fa-info-circle
                      template(slot='popover')
                        .pa-4(v-if='i==1')
                          div(v-if='reactivos[i-1].respuesta == true')
                            | ¡Excelente! Ahora asegúrate de que  cuentas con los siguientes documentos:
                            ul
                              li Identificación oficial vigente
                              li CURP
                              li Acta de nacimiento
                              li Acta de matrimonio (cuando proceda)
                            | Si eres extranjero,  reúne:
                            ul
                              li Tarjeta residente (temporal o permanente) o
                              li Pasaporte y forma migratoria FM2 o FM3.
                          div(v-if='reactivos[i-1].respuesta == false')
                            | Si eres menor de 18 años, espera a cumplir tu mayoría de edad.
                            |  Si eres mayor de 65 años, tienes la opción de contratar tu crédito a 5 o 10 años. 
                            |  Lo importante es que no superes los 75 años durante el plazo del crédito.   
                        .pa-4(v-if='i==2 ')
                          div(v-if='reactivos[i-1].respuesta == true')
                            | Si eres Persona Física Asalariada, reúne:
                            ul
                              li Recibos de nómina (últimos tres meses).
                              li Carta membretada de la empresa en que trabajas.
                            | Si eres Persona Física Independiente o con Actividad Empresarial, reúne:
                            ul
                              li Alta ante SHCP. 
                              li Declaración anual ISR (último año).
                              li Estados de cuenta de los últimos tres  meses.
                          div(v-if='reactivos[i-1].respuesta == false')
                            | Si no tienes manera de comprobar la antigüedad de tu empleo o los  ingresos que percibes, queda la alternativa de pagar por adelantado el equivalente a seis mensualidades del monto total que solicitas. También debes contar con un aval y aceptar que se te realice un estudio socioeconómico. 
                        .pa-4(v-if='i==3 ')
                          div(v-if='reactivos[i-1].respuesta == true')
                            | Consigue cualquiera de los siguientes comprobantes de domicilio:
                            ul
                              li Agua
                              li Teléfono
                              li Estado de cuenta bancario
                              li Gas
                              li Luz
                          div(v-if='reactivos[i-1].respuesta == false')
                            | Los conocimientos que has adquirido se basan en el manejo de los Créditos Hipotecarios en México, por lo que no serán tan útiles si vives en otro país. 

                        .pa-4(v-if='i==4 ')
                          div(v-if='reactivos[i-1].respuesta == true')
                            | ¡¡Felicidades! Este es un factor clave para que cualquier banco apruebe tu Crédito Hipotecario y fije el monto que te prestará. 
                          div(v-if='reactivos[i-1].respuesta == false')
                            | En el caso de no contar con Historial Crediticio, no te preocupes. Es fácil comenzar.
                            br
                            br
                            a(href=" https://www.bancomer.com/personas/productos/tarjetas-de-credito.html" target="_blank" )  consulta esta liga.
                            br
                            br
                            | Si estás en buró de crédito, lamentamos informarte que no eres candidato a un Crédito Hipotecario 
            
            v-btn#attachDialog_10_1.btn(depressed, justify-space-between, type='button ', color='secondary ', :disabled='!completo ', @click.prevent="nextPage( 'page7-2'); sendResult(); ")
              | Continuar
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import jsPDF from 'jspdf';
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      msg: 'This is a button',
      reactivos: [{
          descripcion: '1. Edad: 18 a 64 años/11 meses',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, lo sentimos, no eres sujeto de crédito hipotecario.',
          nocumple: ['Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, tienes la',
                      'opción de contratar tu crédito a 5 o 10 años. Lo importante es que no superes los 75 años durante',
                      ' el plazo del crédito.   ']
        },
        {
          descripcion: '2. Comprobar antigüedad en el empleo de 3 meses.',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: '¡No tienes que ser asalariado! Revisa las siguientes opciones con las que cuentas: - Persona física independiente o con actividad empresarial puede comprobar con: - Alta ante SHCP - Declaración anual ISR (último año) - Estados de cuenta de los últimos 6 meses.',
          nocumple: ['Si no tienes manera de comprobar la antigüedad de tu empleo o los  ingresos que percibes, queda la ',
                    'alternativa de pagar por adelantado el equivalente a seis mensualidades del monto total que solicitas.',
                    ' También debes contar con un aval y aceptar que se te realice un estudio socioeconómico.']

        },
        {
          descripcion: '3. Ser residente de México, ya seas mexicano o extranjero',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, lo sentimos, no eres sujeto de crédito hipotecario.',
          nocumple: ['Los conocimientos que has adquirido se basan en el manejo de los Créditos Hipotecarios en México, por ',
                      'lo que no serán tan útiles si vives en otro país.']
        },
        {
          descripcion: '4. Buen historial crediticio',
          respuesta: 'none',
          correcta: true,
          resultado: 'none',
          tooltip: 'Si eres menor de 18 años, espera a cumplir tu mayoría de edad. Si eres mayor de 65 años, lo sentimos, no eres sujeto de crédito hipotecario.',
          nocumple: ['En el caso de no contar con Historial Crediticio, no te preocupes. Es fácil comenzar. ',
                    'Consulta https://www.bancomer.com/personas/productos/tarjetas-de-credito.html Si estás en buró de crédito, ',
                    'lamentamos informarte que no eres candidato a un Crédito Hipotecario']
        }
      ],
      progress: false,
      dialog: false,
    }
  },
  computed: {
    completo: function() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == 'none') {
          complete = false;
        }
      })
      if (complete) {
        this.$parent.steps_calc.step1 = true;
      }
      return complete;
    },
    resultado: function() {
      var resultado = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == true) {
          resultado++;
        }
      })
      return resultado;
    }
  },
  methods: {
    downloadPDF() {
      var lineSpace = 7;
      var doc = new jsPDF()
      doc.text('Cumplimiento de requisitos para Crédito Hipotecario', 10, 10)
      doc.setFontSize(12);
      this.reactivos.forEach(function(reactivo, index) {
        if (reactivo.respuesta) {
          doc.setTextColor(0, 255, 0);
          doc.text("[Cumple]", 10, 20 + lineSpace * index);
        } else {
          doc.setTextColor(255, 0, 0);
          doc.text("[No Cumple]", 10, 20 + lineSpace * index);
        }
        doc.setTextColor(0, 0, 0);
        doc.text(reactivo.descripcion, 35, 20 + lineSpace * index);
      })
      doc.save('requisitos.pdf')
    },
    sendResult() {
      this.sent = true;
      this.$parent.results['page8-1'] = this.reactivos;
      this.$parent.results['page8-1-r'] = this.resultado;
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    testValue(value, test) {
      if (value == test) {
        return 'accent';
      }
      return 'greyNormal'
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>
